import React, { Component } from "react"
import { withRouter } from "react-router-dom"
import Layout from "../Layout"
import { GestorForm } from "../modais"
class GestoresCreateForm extends Component {
  constructor() {
    super()
    this.onSuccess = this.onSuccess.bind(this)
  }
  onSuccess() {
    this.props.history.push("/gestores")
  }
  render() {
    return (
      <Layout tabActive="Gestores de contrato">
        <GestorForm callBackGestores={this.onSuccess} />
      </Layout>
    )
  }
}
export default withRouter(GestoresCreateForm)



// WEBPACK FOOTER //
// ./src/views/gestores/GestoresCreateForm.js